import React, { useRef, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import {
  faAngleRight,
  faEye,
  faEyeSlash,
  faPlug,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Account_Setting_Offcan.css";
import Blue_Btn from "../../../../common/common_btn/blue_btn/Blue_Btn";
import Common_Back_Btn from "../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { useForm } from "react-hook-form";
import Gray_Btn from "../../../../common/common_btn/gray_btn/Gray_Btn";
import PasswordChecklist from "react-password-checklist";

const Account_Setting_Offcan = ({ show, handleClose }) => {
  const fileInputRef = useRef(null);
  const [profileImg, setProfileImg] = useState(
    "/assets/images/header/profile/user1.png"
  );

  const [isEdit, setIsEdit] = useState();

  const handlePlusClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Only images
    if (!file.type.startsWith("image/")) return;

    // Create preview URL
    const previewUrl = URL.createObjectURL(file);
    setProfileImg(previewUrl);
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setError,
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEye);
  const [iconTwo, setIconTwo] = useState(faEye);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  return (
    <Offcanvas
      className="Basic_Info_Offcan common_offcanvas Profile_Offcanvas Account_Setting_Offcan"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn backText="Account Settings" />
          </div>
        </Offcanvas.Title>

        <div className="profile_top_div">
          <div className="pro_pic_div">
            <img src={profileImg} className="pro_img" alt="profile" />
          </div>
          <div className="plus_icon_div" onClick={handlePlusClick}>
            <FontAwesomeIcon icon={faPlus} className="plus_icon" />
          </div>

          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="body_div">
          {!isEdit ? (
            <>
              <Form className="add_form all_tabs_holder">
                <div className="white_box">
                  <Form.Group className="form_group" controlId="formBasicName">
                    <Form.Label>Current Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter Current Password"
                    />

                    {errors?.credit_price && (
                      <Form.Text className="text-danger">
                        {errors?.credit_price?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </Form>

              <div className="offcanvas_footer">
                <p className="bold_text">Password Change: </p>
                <p className="simple_text">
                  Do you want to change your password? Please confirm to
                  proceed.
                </p>

                <div className="btn_div">
                  <Gray_Btn
                    btnText={"Edit"}
                    onClick={() => {
                      setIsEdit(true);
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <Form className="add_form all_tabs_holder">
                <div className="white_box">
                  <Form.Group className="form_group" controlId="formBasicName">
                    <Form.Label>Current Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter Current Password"
                    />

                    {errors?.credit_price && (
                      <Form.Text className="text-danger">
                        {errors?.credit_price?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="gray_input_box">
                  <Form.Group className="mb-3" controlId="">
                    <Form.Label>New Password</Form.Label>
                    <div className="password-field-holder">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter Password*"
                        name="password"
                        {...register("password", {
                          required: "Password is required",
                          minLength: {
                            value: 8,
                            message:
                              "Password must be at least 8 characters long",
                          },
                          pattern: {
                            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                            message:
                              "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                          },
                        })}
                        onChange={(e) => setPassword(e.target.value)}
                      />

                      <div className="eye-icon-holder">
                        <FontAwesomeIcon
                          icon={iconOne}
                          className="eye-icon"
                          onClick={() => togglePasswordVisibility("password")}
                        />
                      </div>
                    </div>{" "}
                    {errors?.password && (
                      <sup className="text-danger">
                        {errors?.password?.message}
                      </sup>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="">
                    <Form.Label>Confirm Password</Form.Label>
                    <div className="password-field-holder">
                      <Form.Control
                        type={showPasswordOne ? "text" : "password"}
                        placeholder="Re-Enter Password*"
                        name="re_password"
                        {...register("re_password", {
                          required: "Re-Password is required",
                        })}
                        onChange={(e) => setPasswordAgain(e.target.value)}
                      />

                      <div className="eye-icon-holder">
                        <FontAwesomeIcon
                          icon={iconTwo}
                          className="eye-icon"
                          onClick={() =>
                            togglePasswordVisibility("reenterPassword")
                          }
                        />
                      </div>
                    </div>
                    {errors?.re_password && (
                      <sup className="text-danger">
                        {errors?.re_password?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="white_box">
                  {password && (
                    <PasswordChecklist
                      rules={[
                        "minLength",
                        "specialChar",
                        "number",
                        "capital",
                        "match",
                      ]}
                      minLength={8}
                      value={password}
                      valueAgain={passwordAgain}
                      onChange={(isValid) => {}}
                      style={{
                        fontSize: "10px",
                        padding: "4px",
                        margin: "0",
                      }}
                    />
                  )}
                </div>
              </Form>

              <div className="offcanvas_footer">
                <div className="btn_div">
                  <Gray_Btn
                    btnText={"Save"}
                    onClick={() => {
                      handleClose();
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Account_Setting_Offcan;
